const EGKSVG = () => {
  return (
    <svg
      height="100%"
      width="100%"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 612 612"
      className="fill-neutralLight">
      <g>
        <g>
          <g>
            <path
              d="M592.715,299.426h-53.297c-10.651,0-19.285-8.635-19.285-19.287c0-10.651,8.634-19.287,19.285-19.287h53.297
				c10.651,0,19.285,8.635,19.285,19.287C612,290.791,603.366,299.426,592.715,299.426z"
            />
          </g>
          <g>
            <path
              d="M305.258,545.183c-9.313,0-17.328-6.675-18.978-15.887l-41.422-231.429h-17.777L199.82,424.383
				c-1.914,8.883-9.769,15.224-18.853,15.224c-0.007,0-0.009,0-0.012,0c-9.092-0.005-16.943-6.357-18.846-15.246l-27.09-126.494
				H19.285C8.634,297.866,0,289.233,0,278.58c0-10.651,8.634-19.287,19.285-19.287h131.325c9.095,0,16.953,6.355,18.858,15.248
				l11.555,53.957l11.631-53.983c1.914-8.881,9.767-15.224,18.853-15.224h49.488c9.34,0,17.338,6.694,18.983,15.889l22.07,123.305
				l40.101-314.819c1.22-9.589,9.354-16.792,19.021-16.848c9.675-0.055,17.883,7.053,19.213,16.627l24.685,177.407h64.259
				c10.651,0,19.285,8.635,19.285,19.287c0,10.651-8.634,19.287-19.285,19.287h-81.048c-9.624,0-17.775-7.095-19.102-16.628
				l-7.053-50.688l-37.727,296.227c-1.206,9.447-9.124,16.602-18.646,16.843C305.586,545.181,305.42,545.183,305.258,545.183z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EGKSVG;
